import React from 'react';
import { connect } from 'react-redux';

import { Button, Form, SidebarContent } from 'components';

import { setSidebar } from 'redux/reducers/app';
import { login, logout, register, requestResetPassword } from 'redux/reducers/user';

import styles from './styles.scss';

const ERROR_CODES = {
  default: kroostApp.strings.loginFailed,
  'user-invalid-role': kroostApp.strings.loginErrorMessage,
};

@connect(
  state => ({
    validCode: state.getIn(['giftcards', 'code'], false),
    loading: state.getIn(['user', 'loading'], false),
    failedLogin: state.getIn(['user', 'failedLogin'], false),
  }),
  {
    login,
    logout,
    register,
    requestResetPassword,
    setSidebar,
  }
)
export default class Login extends React.PureComponent {
  constructor(props, context) {
    super(props, context);

    this.state = {
      form: props.sidebar || 'login',
      passwordRequested: false,
      firstname: null,
      email: null,
      password: null,
      terms: false,
    };
  }

  showRegistration = e => {
    e.preventDefault();
    this.setState({
      form: 'registration',
      passwordRequested: false,
    });
  };

  showLogin = e => {
    e.preventDefault();
    this.setState({
      form: 'login',
      passwordRequested: false,
    });
  };

  showPassword = e => {
    e.preventDefault();
    this.setState({
      form: 'password',
      passwordRequested: false,
    });
  };

  register = e => {
    e.preventDefault();
    const { first_name, email, password } = this.state;
    this.props.register(first_name, email, password, 'saveSuccess');
  };

  login = e => {
    e.preventDefault();
    const { email, password } = this.state;
    this.props.login(email, password);
  };

  requestResetPassword = e => {
    e.preventDefault();
    const { email } = this.state;
    this.props.requestResetPassword(email);
    this.setState({
      passwordRequested: true,
    });
  };

  onChange = e => {
    const input = e.currentTarget;

    this.setState({
      [input.name]: input.type === 'checkbox' ? input.checked : input.value,
    });
  };

  toMyOrders = e => {
    this.props.setSidebar('myOrders');
  };

  toGiftcards = e => {
    this.props.setSidebar('giftcard');
  };

  render() {
    const { form, first_name, terms, email, password, passwordRequested } = this.state;
    const { failedLogin, validCode, loading } = this.props;
    const errorMessage = failedLogin ? ERROR_CODES[failedLogin] || ERROR_CODES.default : null;

    if (form === 'login') {
      const action = [];

      return (
        <SidebarContent title={kroostApp.strings.loginCredentialsTitle} anchorActionsBottom actions={action}>
          <form method="POST" onSubmit={this.login}>
            <Form.Row>
              <Form.Input
                name="email"
                type="email"
                label={kroostApp.strings.loginEmailInputLabel}
                onChange={this.onChange}
              />
            </Form.Row>
            <Form.Row>
              <Form.Input
                name="password"
                className={styles.passwordInput}
                type="password"
                label={kroostApp.strings.loginPasswordInput}
                onChange={this.onChange}
              />
              <Button className={styles.passwordReset} simple onClick={this.showPassword}>
                {kroostApp.strings.loginForgot}
              </Button>
            </Form.Row>

            {errorMessage ? <Form.Error>{errorMessage}</Form.Error> : null}

            <Form.Row className={styles.actions}>
              <Button cta type="submit" className={styles.submit} disabled={!email || !password} onClick={this.login}>
                {kroostApp.strings.login}
              </Button>
            </Form.Row>

            {validCode ? (
              <Form.Row className={styles.actions}>
                <Button secondary className={styles.createAccount} onClick={this.showRegistration}>
                  {kroostApp.strings.loginNoAccount}
                </Button>
              </Form.Row>
            ) : null}

            {!validCode ? (
              <Form.Row className={styles.actions}>
                <Button secondary className={styles.createAccount} onClick={this.toGiftcards}>
                  {kroostApp.strings.voucherPersonalCode}
                </Button>
              </Form.Row>
            ) : null}
          </form>
        </SidebarContent>
      );
    } else if (form === 'password') {
      return (
        <SidebarContent title={kroostApp.strings.forgotPasswordSectionTitle}>
          <form method="POST" onSubmit={this.requestResetPassword}>
            <Form.Row>
              <Form.Input
                name="email"
                type="email"
                label="E-mail"
                placeholder={kroostApp.strings.forgotPasswordEmailPlaceholder}
                onChange={this.onChange}
              />
            </Form.Row>

            {passwordRequested ? (
              <Form.Row>
                {kroostApp.strings.passwordRequestSend}
                <Button onClick={this.showLogin}>{kroostApp.strings.backToLogin}</Button>
              </Form.Row>
            ) : (
              <span>
                <Form.Row className={styles.actions}>
                  <Button
                    cta
                    type="submit"
                    className={styles.submit}
                    disabled={!email}
                    onClick={this.requestResetPassword}>
                    {kroostApp.strings.loginSendNew}
                  </Button>
                </Form.Row>

                <Form.Row className={styles.back}>
                  <Button simple onClick={this.showLogin}>
                    {kroostApp.strings.passwordRequestRemember}
                  </Button>
                </Form.Row>
              </span>
            )}
          </form>
        </SidebarContent>
      );
    } else {
      return (
        <SidebarContent title={kroostApp.strings.makeAccountTitleStep1}>
          <form method="POST" onSubmit={this.register}>
            <Form.Row className={styles.description}>{kroostApp.strings.loginIntro}</Form.Row>
            <Form.Row>
              <Form.Input
                name="first_name"
                type="text"
                label={kroostApp.strings.signupFirstNameInputLabel}
                placeholder={kroostApp.strings.signupFirstNamePlaceholder}
                onChange={this.onChange}
              />
            </Form.Row>
            <Form.Row>
              <Form.Input
                name="email"
                type="email"
                label={kroostApp.strings.signupEmailInputLabel}
                placeholder={kroostApp.strings.loginEmailInputLabel}
                onChange={this.onChange}
              />
            </Form.Row>
            <Form.Row>
              <Form.Input
                name="password"
                type="password"
                label={kroostApp.strings.signupPasswordInputLabel}
                placeholder={kroostApp.strings.loginPasswordInput}
                onChange={this.onChange}
              />
            </Form.Row>
            <Form.Row>
              <Form.Checkbox
                name="terms"
                checked={terms}
                label={
                  <span>
                    {kroostApp.strings.acceptPrivacyStatementFirstPart}
                    <a
                      href={`https://kroost.${
                        global.kroostApp.domainExtension}/designer-terms`}
                      target="_blank">
                      {kroostApp.strings.acceptPrivacyStatementSecondPart}
                    </a>
                  </span>
                }
                onChange={this.onChange}
              />
            </Form.Row>

            {errorMessage ? <Form.Error>{errorMessage}</Form.Error> : null}

            <Form.Row className={styles.actions}>
              <Button
                cta
                type="submit"
                className={styles.submit}
                disabled={loading || !first_name || !email || !password || !terms}
                onClick={this.register}>
                {kroostApp.strings.accountCreate}
              </Button>
            </Form.Row>

            <Form.Row className={styles.back}>
              <Button secondary onClick={this.showLogin}>
                {kroostApp.strings.accountAlready}
              </Button>
            </Form.Row>
          </form>
        </SidebarContent>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/login/index.js